export default "__VITE_ASSET__DJ2Jh2Ga__"